if (!customElements.get('solution-module')) {
  class SolutionModule extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this._played = false;
      this._initAnimation();
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
      if (this._tl) this._tl.kill();
    }

    _initAnimation() {
      const featuredImage = this.querySelector('[data-featured_image]');
      const hoverImage    = this.querySelector('[data-hover_image]');
      const shadowSlice   = this.querySelector('[data-shadow-slice]');

      if (!featuredImage && !hoverImage) return;

      const dur = 0.5;
      this._tl = new TimelineLite({ paused: true });

      if (shadowSlice) {
        this._tl.to(shadowSlice, dur * 0.6, { opacity: 1, scale: 1 }, '<');
      }

      if (featuredImage && hoverImage) {
        this._tl
          .fromTo(featuredImage, dur,
            { opacity: 1, filter: 'blur(0)' },
            { opacity: 0, filter: 'blur(5px)' }, '<')
          .fromTo(hoverImage, 0.1,
            { opacity: 0 },
            { opacity: 1 }, '<')
          .fromTo(featuredImage, dur,
            { transform: 'translateX(0) translateY(0) rotate(0)', ease: 'cubic-bezier(0.45, 0.01, 0.07, 1.01)' },
            { transform: 'translateX(1%) translateY(-6%) rotate(14deg) rotateY(-10deg)', ease: 'cubic-bezier(0.45, 0.01, 0.07, 1.01)' }, '<')
          .fromTo(hoverImage, dur,
            { transform: 'translateX(-2%) translateY(1%) rotate(-13deg)', ease: 'cubic-bezier(0.45, 0.01, 0.07, 1.01)' },
            { transform: 'translateX(1%) translateY(-6%) rotate(0deg)', ease: 'cubic-bezier(0.45, 0.01, 0.07, 1.01)' }, '<');
      }

      this._observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this._played) {
            this._played = true;
            this._observer.disconnect();
            setTimeout(() => this._tl.play(), 300);
          }
        });
      }, { threshold: 0.25 });

      this._observer.observe(this);
    }
  }

  customElements.define('solution-module', SolutionModule);
}
